<template>
<ScreenLayout :leftVisible="false">

<div class="red lighten-3 pa-4" v-if="vtwo">
    This is an outdated version of Taco. Please update your links to https://taco.insightprocessing.com.au
</div>

<v-toolbar slot="header" dark dense class="primary">
    <v-toolbar-title class="white--text">Taco</v-toolbar-title>

    <v-spacer></v-spacer>

    <AlgoliaContacts v-if="tenantKey == '1'" @select="showActionsForAlgoliaContact" @jump="goToLatestTransaction" ref="algoliaSearch"/>

    <v-menu v-model="addMenuVisible" left bottom origin="top left" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
        <v-btn xcolor="blue darken-3" v-on="on" icon>
            <v-icon>mdi-account-plus</v-icon>
        </v-btn>
        </template>
        <v-list>
            <v-list-item @click="addClients">
                <v-list-item-action>
                    <v-icon>supervisor_account</v-icon>
                </v-list-item-action>                 
                <v-list-item-title>Add Client</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item @click="editContact(null)">
                <v-list-item-action>
                    <v-icon>account_circle</v-icon>
                </v-list-item-action>
                <v-list-item-title>Add Contact</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>

    <v-menu :max-height="510" left bottom origin="top left" :nudge-bottom="43" :nudge-right="21" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
            <v-icon>menu</v-icon>
        </v-btn>
        </template>
        <v-list>
            <!-- <v-list-item @click="$router.push('/' + tenantKey + '/supplier-checklist')">
                <v-list-item-title>Old Document Checklist</v-list-item-title>
            </v-list-item> -->

            <v-list-item @click="$router.push('/living')">
                <v-list-item-title>Living Expense Tool</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/' + tenantKey + '/charts/select')">
                <v-list-item-title>Charts</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/' + tenantKey + '/charts/rotate')">
                <v-list-item-title>Cycle Charts</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/' + tenantKey + '/transaction/' + masterKey)">
                <v-list-item-title>Open Master Template</v-list-item-title>
            </v-list-item>
            <v-list-item @click="emailOfficeInvite">
                <v-list-item-title>Send Invite</v-list-item-title>
            </v-list-item>
            <v-list-item @click="isChatting = !isChatting">
                <v-list-item-title>Chat Visible</v-list-item-title>
                <v-icon v-if="isChatting">check</v-icon>
            </v-list-item>
            <v-list-item v-if="isInsight" @click="test">
                <v-list-item-title>Testing</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isInsight" @click="$router.push('/billing')">
                <v-list-item-title>Billing</v-list-item-title>
            </v-list-item>
            <v-list-item @click="reassignTasksDialog.settings.visible = true">
                <v-list-item-title>Reassign All Tasks</v-list-item-title>
            </v-list-item>
            <v-list-item @click="lookupDataDialog.settings.visible = true">
                <v-list-item-title>Lookup Data</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/mail-log')">
                <v-list-item-title>Email Logs</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isInsight" @click="reindexContacts">
                <v-list-item-title>Reindex Contacts</v-list-item-title>
            </v-list-item>
            <v-list-item @click="tasksByLenderSettings.condensed = !tasksByLenderSettings.condensed">
                <v-list-item-title>Condensed</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/download')">
                <v-list-item-title>Contacts Download</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>

    <v-progress-circular @click="stopLoading" v-if="loadingMessage" indeterminate class="white--text"></v-progress-circular>

    <v-menu min-width="260" class="account-menu" v-if="!loadingMessage" left bottom origin="top left" :nudge-top="0" :nudge-right="0" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
            <img width="35" height="35" :src="userImage" class="round clickable">
        </v-btn>
        </template>
        <div class="grey lighten-3" style="width:100%;padding-left:16px;padding-top:14px;padding-bottom:4px;font-size:1.2em"> 
            <img style="float:right;margin-top:-8px;margin-right:6px" width="35" height="35" :src="userImage" class="round clickable">
            <b>{{user | fullName}}</b><br/>
            <span class="grey--text" style="font-size:10px">{{user.email}}</span>
        </div>
        <v-list>
            <v-list-item @click="$router.push('/preferences')">
                <v-list-item-action>
                    <v-icon class="grey--text">settings</v-icon>
                </v-list-item-action>
                <v-list-item-title>Preferences</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showActivityHistory">
                <v-list-item-action>
                    <v-icon class="grey--text">restore</v-icon>
                </v-list-item-action>
                <v-list-item-title>My Activity History</v-list-item-title>
            </v-list-item>
            <div style="max-height:200px;overflow-y:scroll">

            <!-- List offices Todo...remove all code supporting this list-->

            <!-- <v-list-item v-for="(office) in offices" @click.stop="switchToOffice(office)" :key="office.meta.key" :class="{'blue-hilight': isCurrentOffice(office.meta.key)}">
                <v-list-item-action>
                        <v-checkbox @click.stop="toggleOffice(office)" :input-value="office.active"/>
                </v-list-item-action>
                <v-list-item-title>{{office.name}} ({{office.meta.key}})</v-list-item-title>
            </v-list-item> -->
            </div>

        </v-list>
        <div class="white" style="width:100%;padding:10px 16px 16px 16px;text-align:center"> 
            <v-btn @click.native="signOut" class="primary mr-1">Sign Out</v-btn>       
            <v-btn class="primary">Close</v-btn>       
        </div>
    </v-menu>
</v-toolbar>  


<div>

    <!-- ******* Tasks Column ********* -->

    <table style="margin-top:3px;margin-bottom:-2px;margin-left:17px">
        <tr>
            <td>
                <v-icon style="margin-top:3px;margin-right:7px">mdi-account-circle</v-icon>
            </td>
            <td style="padding-right:15px">
                <v-menu offset-y :nudge-bottom="10" :max-height="300" transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                    <div v-on="on" style="display:flex;margin-top:5px;">
                        <div style="font-size:16px;color:#666;white-space:nowrap;cursor:pointer">
                            {{tasksHeading}}
                        </div>
                        <div>
                            <v-icon>mdi-menu-down</v-icon>
                        </div>
                    </div>
                    </template>
                    
                    <v-list>
                        <v-list-item @click="showMyTasks()">
                        <v-list-item-title>My Tasks</v-list-item-title>
                        </v-list-item>
                        <v-divider/>
                        <template v-for="(office, officeIndex) in officesWithUsers" >
                            
                            <v-list-item @click="showOfficeTasks(office)" :key="officeIndex" xclass="grey lighten-4">
                            <v-list-item-title>{{office.name}}</v-list-item-title>
                            </v-list-item>
                            <v-divider :key="'d1' + officeIndex"/>

                            <v-list-item v-for="(userItem, userIndex) in office.users" :key="officeIndex + '-' + userIndex" @click="showUserTasks(office, userItem)">
                            <v-list-item-title style="font-weight:100">{{userItem.firstName}} {{userItem.lastName}}</v-list-item-title>
                            </v-list-item>                            
                            <v-divider :key="'d2' + officeIndex" v-if="office.users.length"/>
                        </template>
               
                    </v-list>
                </v-menu>
            </td>
    
            <td>
                <v-icon style="margin-top:3px;">mdi-calendar-range</v-icon>
            </td>
            <td class="pt-1">
                <LabelMenu v-model="searchDuration" :menus="[{value: 'Today'}, {value: 'Week'}, {value:'All Upcoming'}]" />
            </td>
            <td width="50" style="text-align:right">
                <v-btn icon @click="goToDashboards">
                    <v-icon color="grey">insert_chart</v-icon>
                </v-btn>
            </td>
        </tr>
    </table>

    <!-- Tasks  -->

        <div v-if="true" class="mb-3">

            <Announcements />
            <TaskWarnings :tasks="filteredLocalTasks" />
            <TasksByLender v-if="searchDuration != 'Week'" :settings="tasksByLenderSettings" :tasks="filteredLocalTasks" @clicked="taskClicked"/>
            <KanbanView v-if="searchDuration == 'Week'" v-slot="{item:task}" :stages="kanbanViewStages" :items="filteredLocalTasks" fieldPath="due" @move="kanbanMoved" @click="taskClicked">
                    <div style="position:relative;margin:2px;border-radius:3px;padding:5px;width:236px;border:dotted 1px #ccc" class="hoverable clickable">
                        <div v-if="task.important" style="position:absolute;width:12px;height:12px;top:4px;right:4px;background-color:rgba(23, 124, 224, 0.6);border-radius:5px;"></div>
                        {{task.clients}} <span class="light-text">{{task.title}}</span>
                    </div>
            </KanbanView>
         
            <div class="center-text">
                <v-btn rounded depressed dark color="red lighten-2" v-if="overdueFilteredTasks.length" class="mt-4" style="width:300px" @click="bringForward">
                    Reschedule {{overdueFilteredTasks.length}} Overdue to Today
                </v-btn>
                <div v-if="search.length" class="ma-4">
                    <div class="light-text">Tasks are filtered based on search text</div>
                    <v-btn rounded depressed class="ma-1" @click="clearSearch" style="width:300px">
                        Clear Search
                    </v-btn>
                </div>
            </div>
            <NoRecordsPlaceholder v-if="!filteredLocalTasks.length">
                No tasks
            </NoRecordsPlaceholder>
            
        </div>
</div>

<!-- ********************* Right Column *********************** -->

<div slot="right">
    <div style="">
        <div v-if="debugInfinite"></div>
        <OfficeChooser style="padding:8px;margin-bottom:-16px" buttonStyle="background-color: rgba(0,0,0,0.4);color:white;"/>
    </div>
    <ContactSearch ref="contactSearch" :global="true" @click="contactClicked" @add="addMenuVisible = true" @search="contactSearchChanged" @jump="goToLatestTransaction" class="no-padding ma-2"/>
</div>



<!-- ********************* Dialogs *********************** -->

<template>

<!-- Rename Transaction -->

<v-dialog v-if="renameTransactionDialog.visible" min-width="300" max-width="300" v-model="renameTransactionDialog.visible" :hide-overlay=false scrollable>
    <div class="dialog-container rounded pa-3">
        <v-text-field ref="oldTransactionName"
            @keypress.enter="saveRename"
            label="Rename to"
            placeholder="Transaction Name"
            :value="renameTransactionDialog.transaction.description"
            hint="Enter to continue..."
          ></v-text-field>
    </div>
</v-dialog>


<!--Contact Actions -->

    <v-dialog min-width="500" max-width="500" v-model="actionDialog.visible" :fullscreen="$vuetify.breakpoint.smAndDown" :hide-overlay=false scrollable>

    <div :style="{height: dialogHeight}" class="dialog-container">

        <div class="dialog-header">
            <v-toolbar dark flat dense class="primary">
                <v-toolbar-title class="white--text">{{actionDialog.model | fullName}}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-menu bottom left :nudge-width="200">
                    <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" dark>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    </template>
                    <v-list>          
                        <template v-if="isInsight">
                        <v-list-item @click="openFirebase(actionDialog.model.meta.key)"> 
                            <v-list-item-title>View Data</v-list-item-title>
                        </v-list-item>      
                        <v-list-item @click="viewContactTransactionData(actionDialog.model.meta.key)"> 
                            <v-list-item-title>View Contact Transaction Data</v-list-item-title>
                        </v-list-item>      
                        <v-list-item @click="viewUserData(actionDialog.model.meta.key)"> 
                            <v-list-item-title>View User Data</v-list-item-title>
                        </v-list-item>      
                        <v-list-item @click="showContactMaintenance(actionDialog.model)"> 
                            <v-list-item-title>Contact Maintenance</v-list-item-title>
                        </v-list-item>      
                        <v-list-item @click="showCharge(actionDialog.model)"> 
                            <v-list-item-title>Charge Invoice</v-list-item-title>
                        </v-list-item>  
                        <v-list-item @click="editPreferences(actionDialog.model)"> 
                            <v-list-item-title>Edit Preferences</v-list-item-title>
                        </v-list-item> 
                        </template>

                        <v-list-item @click="viewEmailLogs(actionDialog.model.email)"> 
                            <v-list-item-title>View Mail Logs</v-list-item-title>
                        </v-list-item>  
                        <v-list-item @click="removeUserStatus(actionDialog.model)"> 
                            <v-list-item-title>Remove User Status</v-list-item-title>
                        </v-list-item>  
                     
                    </v-list>
                </v-menu>

            </v-toolbar>

            <div class="blue lighten-4" style="padding: 7px 20px 7px 20px">
                <template v-if="actionDialog.model.partner">
                    Partner: <a href="#" @click.stop.prevent="switchToPartner(actionDialog.model.partner.key)">{{actionDialog.model.partner.firstName + ' ' + actionDialog.model.partner.lastName}}</a>&nbsp;|&nbsp;
                    <a href="#" @click.stop.prevent="removeSpouse(actionDialog.model)">Separate</a>
                </template> 
                <template v-else><a href="#" @click.stop="selectSpouse(actionDialog.model)">Add Partner</a></template> 
            </div>

        </div>


        <div class="dialog-body">
            <CommunicationBar :contact="actionDialog.model"/>

            <v-list :ripple="false" two-line style="padding-top:0px">
                <v-subheader style="margin-bottom:-15px">Transactions</v-subheader>
                <template v-for="(transaction, transactionIndex) in actionDialog.transactions">
                    <v-list-item @click="openTransaction(transaction)" :ripple="false"  :key="transaction.key || transaction['.key']">
                        <v-list-item-avatar>
                            <img :src="imagePath(transaction)" />
                        </v-list-item-avatar>
                        <v-list-item-content :ripple="false">
                            <v-list-item-title :ripple="false">
                                {{transaction.name}}{{transaction.description}}  
                            </v-list-item-title>
                            <v-list-item-subtitle>{{transaction.created | longDate}}</v-list-item-subtitle>

                        </v-list-item-content>

                        <v-list-item-action>

                            <div @click.stop>
                            <v-menu bottom left>
                                <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon>
                                    <v-icon color="grey">keyboard_arrow_down</v-icon>
                                </v-btn> 
                                </template>   
                                <v-list>
                                    <v-list-item @click.stop="openTransaction(transaction)">
                                        <v-list-item-title>Open Transaction</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.stop="openChecklist(transaction)">
                                        <v-list-item-title>Open Checklist</v-list-item-title>
                                    </v-list-item>
                                    <v-divider />
                                    <!-- <v-list-item @click.stop="openOldChecklist(transaction)">
                                        <v-list-item-title>Open Old Checklist</v-list-item-title>
                                    </v-list-item> -->
                                    <v-list-item @click="renameTransaction(transaction)">
                                        <v-list-item-title>Rename Transaction</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="deleteTransaction(transaction)">
                                        <v-list-item-title>Delete Transaction</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            </div>
            
                        </v-list-item-action>
                    </v-list-item>

                    <v-divider :key="'d1-' + transactionIndex" />
                </template>

                <v-list-item @click.stop="addTransactionForContact(actionDialog.model)">
                <v-list-item-avatar>
                    <v-icon class="text--lighten-1 grey--text" x-large>add_circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Add Transaction
                    </v-list-item-title>
                    <v-list-item-subtitle>New transaction for {{actionDialog.model.firstName}}</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>


            </v-list>        
        </div>

        <div class="dialog-footer">
            <div style="float:left">
                <v-btn text @click.native.stop="editContact(actionDialog.model)">Edit Contact</v-btn>
            </div>
            <v-btn text @click.native="actionDialogClose">Close</v-btn>
        </div>

    </div>
        
    </v-dialog>

    <!--New Transaction Dialog-->

    <v-dialog min-width="500" max-width="500" v-model="transactionDialog.visible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" :hide-overlay=true scrollable>

    <div :style="{height: dialogHeight}" class="dialog-container">

        <div class="dialog-header">
            <v-toolbar dark flat dense class="primary">
                <v-toolbar-title class="white--text">New File for {{transactionDialog.contact.firstName}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon>more_vert</v-icon>
                </v-btn>
            </v-toolbar>
        </div>

        <div class="dialog-body pa-3" >
            <v-text-field ref="transactionName" v-model="transactionDialog.model.description" label="Transaction Name" hint="eg. Refinance home with cashout to purchase car"></v-text-field>     
            <template v-if="transactionDialog.contact.partner">
                <v-checkbox :label="`Joint with ${transactionDialog.contact.partner.firstName}`" v-model="transactionDialog.withPartner" color="primary"></v-checkbox>
            </template>    
            <v-select
            :items="transactionTemplates"
            v-model="transactionDialog.model.masterKey"
            label="Template"
            item-value="meta.key"
            item-text="description"
            ></v-select>   
        </div>

        <div class="dialog-footer">
            <v-btn text @click.native="transactionDialogSave" :disabled="transactionDialog.model.description.length < 1">Save</v-btn>                
            <v-btn text @click.native="transactionDialogCancel">Cancel</v-btn>
        </div>
        
    </div>
        
    </v-dialog>

    <!-- Modal Components -->
 
    <ContactSelector :visible="contactSelector.visible" :title="contactSelector.title" :data="contactSelector.data" @select="linkSpouse" @cancel="contactSelector.visible = false"></ContactSelector>
    <ContactEditor :settings="contactEditor.settings" :contactItem="contactEditor.contact" />
    <AddClients :visible="addClientsVisible" title="Add Clients" @save="savedClients" @cancel="addClientsVisible = false" />
    <GenericListDialog :items="genericListDialog.items" :settings="genericListDialog.settings" :clickHandler="logItemClicked"/>
    <MaintenanceDialog initialProgram="tc" :item="maintenanceDialog.item" :settings="maintenanceDialog.settings"/>
    <EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" :returnObject="emailDialog.returnObject"/>
    <ChargeDialog v-if="chargeDialog.settings.visible" :settings="chargeDialog.settings" :charge="chargeDialog.charge" />
    <ReassignTasksDialog v-if="reassignTasksDialog.settings.visible" :settings="reassignTasksDialog.settings" />
    <LookupDataDialog v-if="lookupDataDialog.settings.visible" :settings="lookupDataDialog.settings" />

    <KeyPress :key-code="191" event="keyup" @pressed="setSearchFocus" />
</template>

<!-- </LayoutContainer> -->
</ScreenLayout>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'
import ScreenLayout from '@/screens/ScreenLayout'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import DeleteButton from '../ui-elements/DeleteButton'
import ContactSelector from '../ui-elements/ContactSelector'
import ContactSearch from '../ui-elements/ContactSearch'
import AddClients from '../ui-elements/AddClients'
import CommunicationBar from '../ui-elements/CommunicationBar'
import TasksByLender from '../ui-elements/TasksByLender'
import ReassignTasksDialog from '../ui-elements/ReassignTasksDialog'
import KanbanView from '../ui-elements/KanbanView'
import TaskWarnings from '../ui-elements/TaskWarnings'
import Flag from '../ui-elements/Flag'
import ContactEditor from '../ui-elements/ContactEditor'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import AppHelpers from '../helpers/AppHelpers'
import Utilities from '../helpers/Utilities'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import StringHelpers from '../helpers/StringHelpers'
import GenericListDialog from '../ui-elements/GenericListDialog'
import MaintenanceDialog from '../ui-elements/MaintenanceDialog'
import FireData from '../data/FireData'
import NiceData from '../data/NiceData'
import TenantHelpers from '../helpers/TenantHelpers'
import Announcements from '../ui-elements/Announcements'
import NoRecordsPlaceholder from '../ui-elements/NoRecordsPlaceholder'
import EmailDialog from '../ui-elements/EmailDialog'
import LabelMenu from '../ui-elements/LabelMenu'
import OfficeChooser from '../ui-elements/OfficeChooser'
import AlertHelpers from '../helpers/AlertHelpers'
import PageHelpers from '../helpers/PageHelpers'
import TransactionHelpers from '../helpers/TransactionHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import CollectionHelpers from '../helpers/CollectionHelpers'
import AlgoliaHelpers from '../helpers/AlgoliaHelpers'
import AlgoliaContacts from '../ui-elements/AlgoliaContacts'
import KeyPress from 'vue-keypress'
import ChargeDialog from '../ui-elements/ChargeDialog'
import CloudHelpers from '../helpers/CloudHelpers'

import Firestore from '../data/Firestore'
import LookupData from '../helpers/LookupData'
import LookupDataDialog from '../ui-elements/LookupDataDialog'

import MilestoneData from '../data/MilestoneData'





    var db = firebase.database()

    var contactsRef //initialised in created
  
    export default {
        name: 'Home',
        components: {
            ReassignTasksDialog,
            ScreenLayout,
            LayoutContainer,
            DeleteButton,
            ContactSelector,
            AddClients,
            CommunicationBar,
            Flag,
            ContactEditor,
            ContactSearch,
            TasksByLender,
            KanbanView,
            TaskWarnings,
            GenericListDialog,
            MaintenanceDialog,
            Announcements,
            NoRecordsPlaceholder,
            EmailDialog,
            LabelMenu,
            OfficeChooser,
            AlgoliaContacts,
            KeyPress,
            ChargeDialog,
            LookupDataDialog,
        },        
       
        data() {
            return {

                milestones: [],
                reassignTasksDialog : {
                    settings: {
                        title: 'Reassign Tasks',
                        visible: false,
                        closeOnly: true,
                    }
                },
                chargeDialog: {
                    settings: {
                        visible: false,
                    },
                    charge: {
                        amount: 0,
                        date: null,
                        from: null, 
                        to: null, 
                        clients: null,
                        description: null,
                    }
                },
                lookupDataDialog: {
                    settings: {
                        closeOnly: true,
                        visible: false,
                    },
                },
                renameTransactionDialog: {
                    transaction: {},
                    visible: false,
                },                
                importantOnly: false,
                transactionTemplates: [],
                taskListeners: [],
                tasksHeading: 'My Tasks',
                localTasks: {},
                tasksByLenderSettings: {
                    showInitials:false,
                    condensed: false,
                },
                loadLimit: 100,
                addMenuVisible: false,
                menuVisible: false,
                selectedUser: {},
                users: [],
                loading: false,
                contacts1: [],
                showingSearch: false,
                search: '',

                actionDialog: {
                    visible: false,
                    transactions: [],
                    showingSMS: false,
                    smsMessage: '',
                    smsPrefix: null,  
                    smsSuffix: null,          
                    model: {
                        firstName: '',
                        lastName: '',
                        email: '',
                        mobile: ''

                    }
                },
                transactionDialog: {
                    visible: false,
                    withPartner: true,
                    contact: {
                        firstName: '',
                        lastName: '',

                    },
                    model: {
                        description: '',
                        masterKey: null,
                    }
                },
                contactSelector: {
                    visible: false,
                    onok: this.linkSpouse,
                    data: {},
                    title: 'Select a Contact'
                },

                contactEditor: {
                    contact: {meta:{}},
                    settings: {
                        visible: false
                    }
                },

                genericListDialog: {
                    settings: {
                        visible: false,
                        title: 'Activity History',
                    },
                    items: []
                },  

                maintenanceDialog: {
                    settings: {
                        visible: false,
                        title: 'Maintenance',
                    },
                    item: {},
                },  
                emailDialog: {

                    email: {
                        to: null,
                        cc: null,
                        bcc: null,
                        subject: null,
                        body: '',
                        attachments: [],
                    },
                    settings: {
                        visible: false,
                        sent: false
                    },
                    returnObject: null,
                },                

                addClientsVisible: false,

                dueTasks: true,
                searchDuration: 'Today',
            }
        },

        watch: {

        },

        computed: {

            masterKey() {
                return LookupData.getMasterKey()
            },

            debugInfinite() {
                console.log('debugging infinite')
                return false
            },

            isChatting: {
                get: function() {
                    return PageHelpers.getPageData('isChatting')
                },
                set: function(newVal) {
                    PageHelpers.setPageData('isChatting', newVal)
                }
            },
            kanbanViewStages() {
                return DateHelpers.nextFiveWorkingDays().map(o => {
                    return {text: o.day, value: o.date}
                })
                return [
                    {value: 'm', text: 'Monday'},
                    {value: 't', text: 'Tuesday'},
                    {value: 'w', text: 'Wednesday'},
                    {value: 'th', text: 'Thursday'},
                    {value: 'f', text: 'Friday'},
                ]
            },
            defaultTransactionTemplateKey() {
                if(this.transactionTemplates.length < 1)
                    return null
                let template = this.transactionTemplates.find(o => o.meta.key)
                if(template)
                    return template.meta.key
                return this.transactionTemplates[0]

            },

            filteredLocalTasks() {
                let tasks = []
                for(let officeKey in this.localTasks) {
                    tasks = [...tasks, ...this.localTasks[officeKey]]
                }

                if(this.search) {
                    const searchedTasks = tasks.filter(o => {
                        if(!o || !o.clients)
                            return false
                        return o.clients.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    })
                    if(searchedTasks.length)
                        return searchedTasks
                }  

                // if(this.dueTasks)
                if(this.searchDuration == 'Today')
                    tasks = tasks.filter(o => o.due <= DateHelpers.todayString())

                if(this.importantOnly)
                    tasks = tasks.filter(o => o.important)
       
                return tasks
            },

            dialogHeight() {
                if(this.$vuetify.breakpoint.smAndDown)
                    return '100%'
                else
                    return '500px'
            },

            offices() {
                return this.$store.getters.offices
            },

            officesActive() {
                return this.$store.getters.officesActive
            },

            currentOffice() {
                return this.offices.find(o => o.meta.key == this.tenantKey)
            },

            hasMultipleOffices() {
                return (this.offices.length > 1)
            },

            officesWithUsers() {
                let offices = DataHelpers.getOfficesWithRefs()
                offices.forEach(office => {
                    this.$set(office, 'users', [])
                    office.ref.child('contacts').orderByChild('user').equalTo(true).once('value', snap => {
                        const userList = NiceData.snapshotToArray( snap )
                        this.$set(office, 'users', userList)
                        //office.users = NiceData.snapshotToArray( snap )
                    })
                })
                return offices
            },


            contacts() {
                return this.$store.getters.contacts
            },

            loadingContacts() {
                return this.$store.getters.status('searchContacts') == 'Loading' ||
                    this.$store.getters.status('recentContacts') == 'Loading'
            },

            // shallowSearch() {
            //     return this.$store.getters.shallowSearch
            // },

            showAssignedUser() {
                return !this.selectedUser ||
                (this.user.uid && this.selectedUser.uid != this.user.uid)
            },

            selectedUserName () {
                if(this.selectedUser)
                    return (this.selectedUser.firstName + ' ' + this.selectedUser.lastName)
                else
                    return 'Everyone'
            },

            userImage () {
                return this.$store.getters.user.image || '/static/images/loader-basic.gif'
            },
            
            user () {
                return this.$store.getters.user
            },

            contactDialogImageVisible () {
                if(this.contactDialog.model.image && 
                this.contactDialog.model.image.indexOf('transparent') < 0)
                    return true
                else
                    return false
            },

            showLoader () {
                return this.loading && this.$store.getters.loginStatus == "Signed In"
            },

            loadingMessage () {
                return this.$store.getters.loadingMessage
            },

            tenantKey() {
                return this.$store.getters.tenantKey
            },

            isInsight() {
                const user = this.$store.getters.user
                return (DataHelpers.isInsightUser(user))
            },

            overdueFilteredTasks() {
                return this.filteredLocalTasks.filter(o => o.due < DateHelpers.todayString())
            },

            vtwo() {
                return (window.location.hostname.indexOf('vtwo') > -1)
            }

        },
        methods: {

            imagePath(transaction) {
                if(transaction.lender)
                    return '/static/images/lenders/' + transaction.lender + '.jpg'
                else
                    return 'https://placeimg.com/40/40/people/1'
            },

            viewEmailLogs(email) {
                this.$router.push('/mail-log?e=' + email)
            },
            bringForward() {
                this.overdueFilteredTasks.forEach(task => {
                    const changes = {
                        due: DateHelpers.todayString(),
                        meta: task.meta,
                    }
                    NiceData.saveItem(changes)
                })
            },

            showCharge(userObj) {
                //make a copy
                let user = Object.assign({}, userObj)
                
                if(!user.user) {
                    AlertHelpers.showAlert('Can only add charges for users, not clients')
                    return
                }

                let key = NiceData.safelyGetKey(user)
                user.uid = key
                user.key = key
                delete user.meta
                this.chargeDialog.charge.date = DateHelpers.todayString()
                this.chargeDialog.charge.from = DataHelpers.getUser()
                this.chargeDialog.description = ''
                this.chargeDialog.clients = ''
                this.chargeDialog.charge.to = user
                this.chargeDialog.amount = 0
                this.chargeDialog.settings.visible = true
            }, 
            
            editPreferences(user) {
                const key = NiceData.safelyGetKey(user)
                this.$router.push(`/preferences?t=${user.tenantKey}&u=${key}`)
            },

            setSearchFocus() {
                if(this.$refs.algoliaSearch)
                    this.$refs.algoliaSearch.focus()
                else
                    this.$refs.contactSearch.focus()
            },

            isCurrentOffice(officeKey) {
                return officeKey == DataHelpers.getTenantKey()
            },

            async emailOfficeInvite() {
                let officeKey = DataHelpers.getTenantKey()
                const invite = await TenantHelpers.fetchInvite(officeKey)

                this.emailDialog.email.to = []
                this.emailDialog.settings.group = 'System'
                this.emailDialog.settings.template = 'Invite New User'
                this.emailDialog.returnObject = null
                this.emailDialog.settings.customFields = {
                    'office': invite.name,
                    'invite_code': officeKey,
                    'pin': invite.write
                }
                this.emailDialog.settings.visible = true 
    
            },

            kanbanMoved(changes) {
                //from, to, fromText, toText, id
                let task = this.filteredLocalTasks.find(t => t.meta.key == changes.id)
                let newTask = {...task}
                newTask.due = changes.to
                NiceData.saveItem(newTask)
                AlertHelpers.showAlert('Moved from ' + changes.fromText + ' to ' + changes.toText)
            },

            contactSearchChanged(search) {
                console.log('search for ....' + search)
                this.search = search || ''
            },

            clearSearch() {
                this.$refs.contactSearch.clearSearch()
            },

            logItemClicked(item) {
                if(item.type == 'email') {
                    this.emailDialog.email = item.email
                    this.emailDialog.settings.sent = true
                    this.emailDialog.settings.visible = true
                }
            },
            clearListeners() {
                this.officesActive.forEach(office => {
                    this.taskListeners.forEach(taskListener => {
                        let ref = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('tasks')
                        ref.off('value', taskListener)
                    })
                })
                this.taskListeners = []
            },

            showOfficeTasks(office) {
                this.clearListeners()
                this.localTasks = {}
                let ref = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('tasks')
                this.taskListeners[0] = ref.on('value', snap => {
                    this.$set(this.localTasks, office.meta.key, NiceData.arrayFromSnapshot(snap))
                    
                })
                this.tasksHeading = office.name || 'Tasks for Office'
                this.tasksByLenderSettings.showInitials = true
            },

            showUserTasks(office, user) {
                this.clearListeners()
                this.localTasks = {}
                let ref = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('tasks')
                this.taskListeners[0] = ref.orderByChild('assigned/uid').equalTo(user.key).on('value', snap => {
                    this.$set(this.localTasks, office.meta.key, NiceData.arrayFromSnapshot(snap))
                })
                this.tasksHeading = ContactHelpers.fullName(user) || 'Tasks for User'
                this.tasksByLenderSettings.showInitials = false
            },
            
            showMyTasks() {
                this.clearListeners()

                let index = -1
                let uid = DataHelpers.getUserId()
                let refs = []
                this.localTasks = {}

                this.officesActive.forEach(office => {
                    index += 1
                    refs[index] = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('tasks').orderByChild('assigned/uid').equalTo(uid)
                    this.taskListeners[this.taskListeners.length] = refs[index].on('value', snap => {
                        let tasks = NiceData.arrayFromSnapshot(snap)
                        this.$set(this.localTasks, office.meta.key, tasks)
                    })                  
                })
                this.tasksHeading = 'My Tasks'
                this.tasksByLenderSettings.showInitials = false                
            },

            goToDashboards() {
                this.$router.push('/dashboards')
            },

            showActivityHistory() {
                let ref = DataHelpers.getTenantRef().child('log').orderByChild('userKey').equalTo(DataHelpers.getUserId()).limitToLast(200)
                let items
                FireData.fetchItems(ref).then(result => {
                    result = result.map(item => {
                        let details
                        let title
                        let icon
                        if(item.type == 'element') {
                            title = item.transactionClients
                            details = item.elementTitle + ' changed to ' + (item.value || 'Empty')
                            icon = 'tune'
                        }
                        else if(item.type == 'transaction viewed') {
                            title = item.transactionClients
                            details = 'File Viewed'
                            icon = 'visibility'
                        }
                        else if(item.type == 'email' || item.type == 'send email') {
                            title = item.transactionClients
                            details = item.result && (item.result != 'OK') ? 'Failed email' : 'Sent email'
                            icon = item.result && (item.result != 'OK') ? 'error_outline' :'email'
                        }
                        else {
                            title = item.title
                            details = item.details
                        }

                        return {
                            meta: {
                                listTitle: title,
                                listDetails: details + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                                listIcon:  icon,
                                listHover: JSON.stringify(item.email, null, 4)
                            },
                            ...item
                        }
                    })
                    this.genericListDialog.items = result.reverse()
                    this.genericListDialog.settings.closeOnly = true
                    this.genericListDialog.settings.visible = true                    
                })
            },            

            doNothing() {
                console.log('doing nothing')
            },  

            initials(contact) {
                let initials = ContactHelpers.initials(contact)
                return initials

                //remove?
                if(initials)
                    return '(' + initials + ')'
                else
                    return ''
            },

            deleteTask(task) {
                console.log('home > deleteTask', task)
                // to fix: this.getTenantsRef().child('tasks').child(task['.key']).remove()
            },

            isMobile () {
                return Utilities.isMobile()
            },

            showSMS () {
                if(!Utilities.isMobile()) {
                    this.actionDialog.showingSMS = !this.actionDialog.showingSMS

                    if(!this.actionDialog.showingSMS) {
                        this.actionDialog.smsMessage = ''
                        return
                    }

                    let vm = this
                    if(!this.actionDialog.smsPrefix) {
                        DataHelpers.getSettings('sms').then(function(settings) {
                            vm.actionDialog.smsPrefix = settings.prefix || 'Update'
                            vm.actionDialog.smsSuffix = settings.suffix || '*** This is a system mobile. Please dont reply ***'
                        })                        
                    }


                    this.$nextTick(function(){
                        vm.$refs.smsText.focus()
                    })
                }
            },

            sendSMSMessage () {
                console.log('home > sendSMS')
                let mobile = this.actionDialog.model.mobile
                let message = this.actionDialog.smsPrefix + ': ' + this.actionDialog.smsMessage + '\n' + this.actionDialog.smsSuffix
                Utilities.sendSMS(message, mobile)
                this.actionDialog.smsMessage = ''
                this.actionDialog.showingSMS = false
            },

            stopLoading () {
                this.$store.commit('stopLoading')
            },
            selectUser (user) {
                this.selectedUser = user
            },

            taskClicked (task) {
                if(task.code == "document-checklist" || task.code == 'checklist') //checklist is the old way
                    this.goToChecklist(task.meta.tenantKey, task.transactionKey)
                else 
                    this.goToTransactionForTask(task)
            },

            goToTransactionForTask(task) {
                let tenantKey = task.meta.tenantKey || '999'
                this.goToTransaction(tenantKey, task.transactionKey, task.tabKey)
            },

            goToChecklist(tenantKey, transactionKey) {
                this.$router.push('/' + tenantKey + '/document-checklist/' + transactionKey)
            },

            goToTransaction(tenantKey, transactionKey, tabKey) {
                let path = '/' + tenantKey + '/transaction/' + transactionKey + 
                    (tabKey ? '?tab=' + tabKey : '')
                this.$router.push(path)
            },

            signOut: function() {
                console.log('signing out')
                firebase.auth().signOut()
            },            
            addClients () {
                this.addClientsVisible = true
            },
            savedClients (result) { 
                //result contains {mode: 'checklist', transactionKey: XXX}
                this.addClientsVisible = false
    
                console.log('todo: savedClients mode', result)

                if(result.mode == 'Checklist')
                    this.goToChecklist(result.tenantKey, result.transactionKey)
                if(result.mode == 'Transaction')
                    this.goToTransaction(result.tenantKey, result.transactionKey)
            },
            getTenantsRef () {
                return db.ref('tenants/' + this.$store.getters.tenantKey)
            },
            getContactsRef () {
                return this.getTenantsRef().child('contacts')
            },

            contactClicked(contact) {
                TenantHelpers.setTenant(contact.meta.tenantKey)
                this.showActions(contact)
            },

            showActionsForAlgoliaContact(algoliaContact) {
                const ref = this.getContactsRef().child(algoliaContact.objectID)
                NiceData.fetchItemSingle(ref).then(contact =>{
                    this.showActions(contact)
                })
            },

            showActions (contact) {

                this.actionDialog.model = contact
                
                if(contact.meta)
                    this.loadTransactionsForContact(contact)
                else
                    this.loadTransactions(contact.key)
                this.actionDialog.showingSMS = false
                this.actionDialog.visible = true
            },

            goToLatestTransaction(contact) {
                const key = NiceData.safelyGetKey(contact)
                const tenantKey = NiceData.safelyGetTenant(contact)
                TenantHelpers.setTenant(tenantKey)

                let ref = DataHelpers.getTenantRef().child('contactTransactions').child(key)
                NiceData.fetchItemsFromFirebase(ref).then(transactions => {
                    const lastTransaction = CollectionHelpers.getMostRecentItem(transactions)
                    if(lastTransaction) {
                        this.goToTransaction(DataHelpers.getTenantKey(), lastTransaction.meta.key) 
                    }

                    else
                        AlertHelpers.showAlert('No transactions for ' + contact.firstName)
                })
            },

            async removeUserStatus(contact) {
                if(await this.$root.$confirm('Confirm', 'This will remove contact as a user. Are you sure?', { color: 'red' }) == false)
                    return
                const key = NiceData.safelyGetKey(contact)
                this.getContactsRef().child(key).update({user: null})
                DataHelpers.getRootRef().child('users').child(key).remove()
            },


            switchToPartner (key) {
                let vm = this
                this.getContactsRef().child(key).once('value', function (snap) {
                    let contact = NiceData.objectFromSnapshot(snap)
                    vm.showActions(contact)
                })
            },

            editContact (model) {
                
                if(model) {
                    this.contactEditor.contact = {...model}
                    this.contactEditor.contact.groups = model.groups || null
                } else {
                    this.contactEditor.contact = {
                        meta: {
                            tenantKey: DataHelpers.preferredOffice().meta.key
                        },
                        firstName: '',
                        preferredName: '',
                        lastName: '',
                        mobile: '',
                        email: '',
                        gender: '',
                        image: '/static/transparent.png',
                        groups: null
                    }
                }
                if(this.actionDialog.visible)
                    this.actionDialogClose() 

                this.contactEditor.settings.visible = true
            },
   
            contactDialogClose () {
                this.contactDialog.visible = false
            },
            contactDialogCancel () {
                this.contactDialogClose()
            },

            actionDialogClose () {
                this.actionDialog.visible = false
                let vm = this
                setTimeout(function(){
                    vm.actionDialog.transactions = []
                },300)
            },
            actionDialogCancel () {
                this.actionDialogClose()
            },
            addTransactionForContact(contact) {
                this.transactionDialog.contact = contact
                this.transactionDialog.visible = true
                this.$nextTick( () => {
                    this.$refs.transactionName.focus()
                })
                this.actionDialog.visible = false
            },
            transactionDialogClose () {
                this.transactionDialog.model.description = ''
                this.transactionDialog.visible = false
            },
            transactionDialogCancel () {
                this.transactionDialogClose()
            },
            transactionDialogSave () {

                console.log('home > transactionDialogSave')

                let ref

                let tRef = db.ref('tenants').child(this.$store.getters.tenantKey)
                
                let vm = this
                let contact = vm.transactionDialog.contact

                vm.transactionDialog.model.clients = this.jointNames(contact)
                vm.transactionDialog.model.created = DateHelpers.todayString()
                
                // save transaction listing
                tRef.child('transactions').push()
                .then( (snap) => {

                    //save details
                    tRef.child('transactions').child(snap.key).child('details').update(vm.transactionDialog.model)
                    
                    console.log('Made new transaction', snap.key)

                    let contactKey = NiceData.safelyGetKey(contact)
                    let newContact = FirebaseHelpers.cloneWithoutKey(contact)

                    // add primary contact to elements
                    let element = {
                        type: 'Contact',
                        role: 'Client',
                        name: 'client',
                        title: 'Client',
                        value: ContactHelpers.fullName(contact),
                        contact: newContact,
                        transactionKey: snap.key,
                        tabKey: 'settings',
                        contactKey: contactKey
                    }
                    tRef.child('transactions').child(snap.key).child('elements').child(contact.meta.key).update(element)
                    
                    //save transaction for primary
                
                    ref = tRef.child('contactTransactions').child(contact.meta.key).child(snap.key)
                    
                    ref.update(vm.transactionDialog.model)

                    //save partner into transaction
                    if(contact.partner && vm.transactionDialog.withPartner) {

                        let partnerElement = {
                            type: 'Contact',
                            role: 'Client',
                            name: 'client',
                            title: 'Client',
                            value: ContactHelpers.fullName(contact.partner),
                            contact: contact.partner,
                            transactionKey: snap.key,
                            tabKey: 'settings',
                            contactKey: contact.partner.key
                        }

                        tRef.child('transactions').child(snap.key).child('elements').child(contact.partner.key).update(partnerElement)
                        
                        //save transaction for partner
                        tRef.child('contactTransactions/' + contact.partner.key + '/' + snap.key).update(vm.transactionDialog.model)
                    }

                    vm.transactionDialogClose()
                        
                    vm.openTransaction({
                        meta: {
                            key: snap.key,
                            tenantKey: contact.meta.tenantKey
                        }
                    })
                })

            },  
            jointNames (contact) {
    
                if(contact.partner) 
                    if(contact.partner.lastName == contact.lastName)
                        return contact.firstName + ' and ' + contact.partner.firstName + ' ' + contact.lastName
                    else
                        return contact.firstName + ' ' + contact.lastName + ' and ' + contact.partner.firstName + ' ' + contact.partner.lastName
                else
                    return contact.firstName + ' ' + contact.lastName

            },     
            selectSpouse (primaryContact) {
                this.actionDialog.visible = false
                this.contactSelector.visible = true
                this.contactSelector.data = {
                    primaryContact: primaryContact
                }
                this.contactSelector.title = "Connect " + primaryContact.firstName + " to..."
                //this.contactSelector.onok = this.linkSpouse
            },   

            linkSpouse (contact, data) {
                
                this.contactSelector.visible = false

                let ref = DataHelpers.getRootRef().child('tenants').child(data.primaryContact.meta.tenantKey).child('contacts').child(data.primaryContact.meta.key)
                ref.update({
                    partner: this.makeSpouse(contact) 
                })

                ref = DataHelpers.getRootRef().child('tenants').child(contact.meta.tenantKey).child('contacts').child(contact.meta.key)
                
                ref.update({
                    partner: this.makeSpouse(data.primaryContact) 
                })

            },  
            makeSpouse (contact) {
                return {
                    firstName: contact.firstName,
                    lastName: contact.lastName,
                    key: contact.meta.key
                }
            },
            removeSpouse (contact) {
                let ref = this.getContactsRef().child(contact.partner.key)
                
                ref.update({
                    partner: null 
                })

                //delete contact.partner

                ref = this.getContactsRef().child(contact.meta.key)
                ref.update({
                    partner: null 
                })

                this.actionDialog.model.partner = null

            },

            //todo: remove this old one
            loadTransactions (contactKey) {
                let vm = this
                let ref = this.getTenantsRef().child('contactTransactions').child(contactKey)
                ref.once('value', function(snap) {
                    vm.actionDialog.transactions = FirebaseHelpers.snapshotToArray(snap, true)
                })
            },

            loadTransactionsForContact (contact) {
                let ref = DataHelpers.getRootRef().child('tenants').child(contact.meta.tenantKey).child('contactTransactions').child(contact.meta.key)
                
                ref.once('value', snap => {
                    this.actionDialog.transactions = NiceData.arrayFromSnapshot(snap).reverse()
                    this.actionDialog.transactions.forEach(transaction => {
                        this.attachLender(transaction)
                    })
                })
            },

            async attachLender(transaction) {
                let ref = DataHelpers.getTransactionRef(transaction.meta.key).child('elements')
                const el = await NiceData.fetchItemByName(ref, 'lender')
                if(el && el.value)
                    this.$set(transaction, 'lender', el.value)
            },

            openChecklist(transaction) {
                let key = transaction.meta.key
                let tenantKey = transaction.meta.tenantKey

                this.actionDialogClose()
                this.$router.push({ path: `/${tenantKey}/document-checklist/${key}`})
            },

            openTransaction(transaction) {

                let key = transaction.meta.key
                let tenantKey = transaction.meta.tenantKey

                if(!key || !tenantKey) {
                    debugger
                }
                
                this.actionDialogClose()
                setTimeout( () => {
                    this.$router.push({ path: `/${tenantKey}/transaction/${key}`})
                }, 100)
            },
      
            checkGender() {
                ContactHelpers.setInitialGender(this.contactDialog.model)
            },

            // dueColour (date) {
            //     return StringHelpers.dueColour(date)
            // },
            
            openFirebase (key) {
                let path = FirebaseHelpers.firebaseConsolePath() + "/tenants/"
                path += this.$store.getters.tenantKey + "/contacts/" + key
                window.open(path, '_blank')
            },

            viewTaskData(key) {
                let path = FirebaseHelpers.firebaseConsolePath() + "/tenants/"
                path += this.$store.getters.tenantKey + "/tasks/" + key
                window.open(path, '_blank')
            },
            viewContactTransactionData(key) {
                let path = FirebaseHelpers.firebaseConsolePath() + "/tenants/"
                path += this.$store.getters.tenantKey + "/contactTransactions/" + key
                window.open(path, '_blank')
            },
            viewUserData(key) {
                let path = FirebaseHelpers.firebaseConsolePath() + "/users/"
                path += key
                window.open(path, '_blank')
            },
        
            showContactMaintenance(contact) {
                this.$router.push('/maintenance/?item=' + contact.meta.key + '&action=tc')
            },

            toggleOffice(office, forceTrue) {
                let newActive = forceTrue || !office.active

                // Write to store then db
                
                this.$store.commit('setOfficeActive', {officeNumber: office.meta.key, value: newActive})
                DataHelpers.getUserRef().child('offices').child(office.meta.key).child('active').set(newActive)

                // If I've unchecked a box, then it can't be the current tenant, so set current to the first active one.
                if(!newActive && office.meta.key == DataHelpers.getTenantKey()) {
                    if(this.officesActive.length) {
                        this.switchToOffice(this.officesActive[0])
                    }
                }

            },

            switchToOffice(office) {
                this.toggleOffice(office, true)
                DataHelpers.initialiseTenant(office.meta.key)
            },

            reindexContacts() {
                const contactsRef = DataHelpers.getTenantRef().child('contacts')
                NiceData.fetchItemsFromFirebase(contactsRef).then(contacts => {
                    ContactHelpers.saveListToAlgolia(contacts)
                })
            },

            async test() {

                const gender = await CloudHelpers.getGender('John')
                console.log('John is a ' + gender)
                
                return

                const mail = {
                    to: [
                        {
                            fullName: 'Matt Ireland',
                            email: 'matt.ireland.home@gmail.com',
                        }
                    ],
                    from: 'linda.a.ireland@gmail.com',
                    fromName: 'Linda Ireland',
                    subject: 'Testing My Email',
                    body: '<b>Hello</b> There',
                    attachments: [
                        {
                            filename: 'Matt.jpg',
                            path: 'https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-Lh7ieLxKdCt15FrR1ht%2FMatt%20Profile.jpg?alt=media&token=5a6c1413-f107-4a71-b3ae-39e8b208a221'
                        },
                    ],
                    status: 'Sending',
                    _path: 'teams/global/collections/mail/data'
                    
                }

                Firestore.saveItem(mail)
                AlertHelpers.showAlert('saved')
                
                return


                AlgoliaHelpers.testSave()
        
                return

                // AppHelpers.exitApplication()
                    
                //     return

                //Cycle all contacts for an office...

                console.log('mobiles***')
                
                let ref2 = DataHelpers.getTenantRef().child('contacts')
                ref2.on('child_added', (snap) => {
                    //console.log(snap.val())
                    let mobile = snap.val().mobile
                    
                    if(mobile) {
                        let newMobile = mobile.replace(/\D/g,'')
                        let mobileSearch = mobile.substr(mobile.length - 3)
                        let key = snap.key
                        console.log(newMobile)
                        console.log(mobileSearch)
                        console.log(key)
                        ref2.child(key).update({
                            mobile: newMobile,
                            mobileSearch: mobileSearch
                        })
                    } 
                })


                return

                DataHelpers.getSettings('sms').then(function(settings) {
                    console.log(settings)
                })

                return

                let ref1 = DataHelpers.getTenantRef().child('transactions')
                ref1.once('value', function(snap) {
                    snap.forEach(function(item){
                        let tran = item.key
                        let ref2 = ref1.child(tran).child('people')
                        ref2.once('value', function(snap2) {
                            snap2.forEach(function(item2){
                                let pers = (item2.key)
                                let ref3 = ref2.child(pers)
                                //console.log(ref3.toString())
                                ref3.update({role: 'Client', isTrusted: null})
                            })
                        })
                    })
                })

                return

                console.log('Initialising')
                let db = firebase.database()
                let ref = db.ref('app/lenders')
                ref.once('value', function(snap) {
                    if(snap.val() != null) {    
                        console.log('Lenders already exist')
                        return
                    }
                    const lenders = LookupData.lenders()
                    lenders.forEach(function(itm) {
                        ref.push(itm)
                    })
                    console.log('Lenders added')

                })

                ref = db.ref('app/documents/categories')
                ref.once('value', function(snap) {
                    if(snap.val() != null) {    
                        console.log('Doc categories already exist')
                        return
                    }
                    let categories = [
                        {name:'Forms', order: 100},
                        {name:'Identification', order: 200},
                        {name:'Income', order:300},
                        {name:'Contribution', order:400},
                        {name:'Commitments', order:500},
                        {name:'Security', order:600},
                        {name:'Other', order:700}
                    ]
                    categories.forEach(function(itm) {
                        ref.push(itm)
                    })
                    console.log('Categories added')

                })
            },

            firstLoad() {


                DataHelpers.fetchUser().then((user) => {
                    this.showMyTasks()
                    this.selectedUser = user

                    ContactHelpers.getUsers().then((users) => {
                        this.users = users
                    })

                    //AppHelpers.initialiseApplication()

                    let ref = DataHelpers.getTenantRef(this.tenantKey).child('transactionTemplates')
                    return NiceData.fetchItemsFromFirebase(ref).then(templates => {
                        
                        this.transactionTemplates = templates
                        
                        let defaultTransactionTemplate = this.transactionTemplates.find(template => template.isDefault || template.description == 'Home Loan')
                        if(defaultTransactionTemplate && defaultTransactionTemplate.meta)
                            this.transactionDialog.model.masterKey = defaultTransactionTemplate.meta.key
                    })

                })
            },

            renameTransaction(transaction) {
                this.renameTransactionDialog.transaction = transaction
                this.renameTransactionDialog.visible = true
                setTimeout( () => {
                    this.$refs.oldTransactionName.focus()
                },500)
            },

            saveRename(event) {
                const val = event.target.value
                if(!val)
                    return
                const transaction = this.renameTransactionDialog.transaction
                const key = transaction.meta.key
                transaction.description = val
                TransactionHelpers.renameTransaction(key, val)
                this.renameTransactionDialog.visible = false
            },

            async deleteTransaction(transaction) {
                if(await this.$root.$confirm('Delete Transaction', 'Delete this transaction and all associated tasks, files and comments?', { color: 'red' }) == true) {
                    const {path, key} = transaction.meta
                    ArrayHelpers.deleteItem(transaction, this.actionDialog.transactions)
                    TransactionHelpers.deleteTransaction(key)

                    //Just to be sure...manually remove from this contacts menu....
                    const contactTransactionRef = DataHelpers.getRootRef().child(path + '/' + key)
                    contactTransactionRef.remove()
                    
                }
            },

            async loadMilestones() {
                this.milestones = await MilestoneData.fetchOpenMilestones()
            }

        },



        created () {

            this.firstLoad()
            //this.loadMilestones()
            
        },


    }

</script>

<style>
    .menuable__content__active { /*Fix for Safari dialog display. Reference Vuetify issue #2111 */ z-index:250!important; }
</style>


// WEBPACK FOOTER //
// Home.vue?327cc27c